export const getTimelineUrl = (versionId?: string, location = window.location) => {
	const timelineUrl = `${location.pathname.split('/calendar')[0]}/timeline`;
	if (versionId) {
		return `${timelineUrl}?version=${versionId}`;
	}
	return timelineUrl;
};
